import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@heroui/react';
import { getNodeTestProps } from '@/utils';
import type { TransactionsPageLogic } from './useTransactionsPage';
import { TransactionsDateBar, TransactionsList } from './components';

/**
 * Transactions page layout (render-only): heading, the day selector, and the
 * self-served list section. The page carries no loading skeleton of its own —
 * the list section provides its own loading + error states.
 */
export const TransactionsView: React.FC<TransactionsPageLogic> = ({
    date,
    setDate,
}) => {
    const { t } = useTranslation('pages');

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestProps('transactions-page')}
        >
            <div className="flex flex-col gap-1">
                <Typography type="h4" weight="bold">
                    {t('transactions.title')}
                </Typography>
                <Typography color="muted" type="body-sm">
                    {t('transactions.subtitle')}
                </Typography>
            </div>

            <TransactionsDateBar onChange={setDate} value={date} />

            <TransactionsList date={date} />
        </div>
    );
};
